import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row} from 'react-material-responsive-grid';
import {AppEnv} from '../../env';
import {pulseLoader} from "../NewFunctions";

const moment = require('moment');
require('moment/locale/es');
moment.locale('es');

export default class SaveButton extends Component {
    static propTypes = {
        styles: PropTypes.object,
        title: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        visible: PropTypes.bool.isRequired,
        size: PropTypes.string,
        colorButton: PropTypes.string,
        textColor: PropTypes.string,
        icon: PropTypes.string,
    };

    static defaultProps = {
        styles: {},
        title: 'Guardar',
        visible: false,
        size: '2',
        colorButton: AppEnv.secondColor,
        textColor: AppEnv.fourthColor,
        icon: "fas fa-save uk-width-1-3"
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible
        };
        this.setVisible = this.setVisible.bind(this);
    }

    setVisible = (visible) => {
        this.setState({visible: visible});
    };

    async onClick() {
        await this.props.onClick();
    }

    async onClick1() {
        this.onClick();
    }


    render() {
        const {textColor} = this.props;
        let styleButton = {
            padding: 10,
            lineHeight: 1,
            backgroundColor: this.props.colorButton,
            borderRadius: 7
        }
        styleButton = Object.assign(styleButton, this.props.styles);
        return (
            <Row className="centerAll uk-width-1-1@s">
                <button data-uk-tooltip={this.props.title}
                        className={'uk-button uk-button-default uk-width-1-' + this.props.size} style={styleButton}
                        onClick={() =>
                            this.onClick1()} disabled={this.state.visible}>
                    {this.state.visible ?
                        <Row className='uk-width-1-1 centerAll'>
                            {pulseLoader(textColor)}
                        </Row>
                        : <Row className='uk-width-1-1 centerAll'>
                            <div style={{color: textColor}}><i className={this.props.icon}/></div>
                            <div className='normal_text uk-width-2-3 uk-text-truncate'
                                 style={{marginLeft: 10, lineHeight: 1, color: textColor}}>
                                {this.props.title}
                            </div>
                        </Row>}
                </button>
            </Row>
        );
    }
}